var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "badge icon-badge",
      class: { "is-hidden": _vm.itemCount === 0 },
      attrs: { id: "cart-icon-badge-count" }
    },
    [_vm._v("\n  " + _vm._s(_vm.itemCount) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }